"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuzzyQueryBankRequest = void 0;
var FuzzyQueryBankRequest = /** @class */ (function () {
    function FuzzyQueryBankRequest() {
    }
    return FuzzyQueryBankRequest;
}());
exports.FuzzyQueryBankRequest = FuzzyQueryBankRequest;
;
//# sourceMappingURL=fuzzyQueryBank.request.js.map